/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Document_Replacement_Target_MismatchInputs */

const es_co2_error_document_replacement_target_mismatch = /** @type {(inputs: Error_Document_Replacement_Target_MismatchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El documento actual cambió. Recarga la página e intenta de nuevo.`)
};

/**

* @param {Error_Document_Replacement_Target_MismatchInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_document_replacement_target_mismatch = /** @type {((inputs?: Error_Document_Replacement_Target_MismatchInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Document_Replacement_Target_MismatchInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_document_replacement_target_mismatch(inputs)
});